export default "__VITE_ASSET__BKkkSggY__"